<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card v-bind:title="'Edit Stock Opname'">
          <template v-slot:body><BatchOpnameCount /></template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import BatchOpnameCount from '@/component/stock-opnames/BatchOpnameCount.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    BatchOpnameCount
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar Stock", route: "/stock-opnames" },
      { title: "Edit Stock Opname" },
    ])
  },

}

</script>
